import React, { useEffect, useMemo, useState } from 'react';

import themes from './theme';

const ToolTip = ({ theme = 'light', stateful = false, customStyles, ...props }) => {
    const [hasMounted, setHasMounted] = useState(false);
    const [Component, setComponent] = useState(<></>);

    useEffect(() => {
        if (stateful) {
            import('./components/StatefulTooltip').then(component => {
                setComponent(component);
                setHasMounted(true);
            });
        } else {
            import('./components/StatelessTooltip').then(component => {
                setComponent(component);
                setHasMounted(true);
            });
        }
    }, [stateful]);

    const additionalStyles = useMemo(() => {
        if (themes[theme]) {
            const { style, arrowStyle } = themes[theme];
            return {
                style: {
                    ...style,
                    ...customStyles?.style,
                },
                arrowStyle: {
                    ...arrowStyle,
                    ...customStyles?.arrowStyle,
                },
            };
        }
    }, [customStyles, theme]);

    return hasMounted && (
        <Component.default
            style={additionalStyles}
            data-test={stateful ? 'stateful' : 'stateless'}
            {...props}
        />
    );
};

export default ToolTip;
